"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParams = exports.spareWheelSearchForm = exports.motorcycleTyreSearchForm = exports.forkliftTyreSearchForm = exports.agriculturalAndIndustrialTyreSearchForm = exports.truckTyreSearchForm = exports.carTyreSearchForm = exports.skuSearchForm = exports.tyreSearchForm = exports.isVanCarTyre = exports.isSuvCarTyre = exports.isPassengerCarTyre = exports.calculateSeason = exports.calculateAxCategory = exports.getIdsForAxCategory = exports.seasonRules = exports.defaultSeason = exports.MAX_HITS = void 0;
const ProductFilter_1 = require("../../models/ProductFilter");
exports.MAX_HITS = 250;
exports.defaultSeason = (() => {
    const currentMonth = new Date().getMonth();
    if (2 > currentMonth || 7 < currentMonth) {
        return "winter";
    }
    return "summer";
})();
exports.seasonRules = {
    summer: {
        passenger: "140",
        suv: "131",
        van: "130",
    },
    winter: {
        passenger: "149",
        suv: "138",
        van: "139",
    },
    all_season: {
        passenger: "145",
        suv: "133",
        van: "135",
    },
};
const getIdsForAxCategory = (category) => {
    const ret = [];
    Object.keys(exports.seasonRules).forEach((season) => {
        ret.push(exports.seasonRules[season][category]);
    });
    return ret;
};
exports.getIdsForAxCategory = getIdsForAxCategory;
const calculateAxCategory = (season = exports.defaultSeason, types = []) => {
    if (season !== "summer" && season !== "winter" && season !== "all_season") {
        return [
            exports.seasonRules[exports.defaultSeason].passenger,
            exports.seasonRules[exports.defaultSeason].suv,
            exports.seasonRules[exports.defaultSeason].van,
        ];
    }
    if (!types.length) {
        return [
            exports.seasonRules[season].passenger,
            exports.seasonRules[season].suv,
            exports.seasonRules[season].van,
        ];
    }
    const ret = [];
    types.forEach((type) => ret.push(exports.seasonRules[season][type]));
    return ret;
};
exports.calculateAxCategory = calculateAxCategory;
const calculateSeason = (axCategory) => {
    const season = Object.keys(exports.seasonRules).find((key) => axCategory.includes(exports.seasonRules[key].passenger) ||
        axCategory.includes(exports.seasonRules[key].suv) ||
        axCategory.includes(exports.seasonRules[key].van));
    return season || exports.defaultSeason;
};
exports.calculateSeason = calculateSeason;
const isPassengerCarTyre = (axCategory) => {
    return (axCategory.includes(exports.seasonRules.summer.passenger) ||
        axCategory.includes(exports.seasonRules.winter.passenger) ||
        axCategory.includes(exports.seasonRules.all_season.passenger));
};
exports.isPassengerCarTyre = isPassengerCarTyre;
const isSuvCarTyre = (axCategory) => {
    return (axCategory.includes(exports.seasonRules.summer.suv) ||
        axCategory.includes(exports.seasonRules.winter.suv) ||
        axCategory.includes(exports.seasonRules.all_season.suv));
};
exports.isSuvCarTyre = isSuvCarTyre;
const isVanCarTyre = (axCategory) => {
    return (axCategory.includes(exports.seasonRules.summer.van) ||
        axCategory.includes(exports.seasonRules.winter.van) ||
        axCategory.includes(exports.seasonRules.all_season.van));
};
exports.isVanCarTyre = isVanCarTyre;
exports.tyreSearchForm = Object.keys(ProductFilter_1.TyreFilters).reduce((o, key) => ({ ...o, [key]: null }), {});
exports.skuSearchForm = Object.keys(ProductFilter_1.SkuProductFilters).reduce((o, key) => ({ ...o, [key]: null }), {});
exports.carTyreSearchForm = Object.assign(Object.keys(ProductFilter_1.CarTyreFilters).reduce((o, key) => ({ ...o, [key]: null }), {}), { axCategories: (0, exports.calculateAxCategory)(), type: "carTyre" });
exports.truckTyreSearchForm = Object.assign(Object.keys(ProductFilter_1.TruckTyreFilters).reduce((o, key) => ({ ...o, [key]: null }), {}), { axCategory: ["122"], type: "truckTyre" });
exports.agriculturalAndIndustrialTyreSearchForm = Object.assign(Object.keys(ProductFilter_1.AgriculturalAndIndustrialTyreFilters).reduce((o, key) => ({ ...o, [key]: null }), {}), { axCategory: ["110", "160"], type: ["agriculturalTyre", "industrialTyre"] });
exports.forkliftTyreSearchForm = Object.assign(Object.keys(ProductFilter_1.ForkliftTyreFilters).reduce((o, key) => ({ ...o, [key]: null }), {}), { axCategory: ["150"], type: "industrialTyre" });
exports.motorcycleTyreSearchForm = Object.assign(Object.keys(ProductFilter_1.MotorcycleTyreFilters).reduce((o, key) => ({ ...o, [key]: null }), {}), { axCategory: ["170"], type: "motorcycleTyre" });
exports.spareWheelSearchForm = Object.assign(Object.keys(ProductFilter_1.SpareWheelFilters).reduce((o, key) => ({ ...o, [key]: null }), {}), { axCategory: ["910"], type: "spareWheel" });
const getQueryParams = (form, route = null) => {
    let params = Object.assign({}, Object.fromEntries(Object.entries(form).filter(([prop, value]) => {
        if (typeof value === "boolean") {
            return value;
        }
        return value !== null;
    })), route ? route.query : {});
    if (params.itemsPerPage) {
        delete params.itemsPerPage;
    }
    if (params.axCategory) {
        params.axCategories = params.axCategory;
        delete params.axCategory;
    }
    if (params.homologatedNotation) {
        params.homologatedNotations = params.homologatedNotation;
        delete params.homologatedNotation;
    }
    return params;
};
exports.getQueryParams = getQueryParams;
